import { useUi } from '../../store/ui';

export function Toasts() {
  const toasts = useUi((s) => s.toasts);
  return (
    <div className="toasts" aria-live="polite" role="status">
      {toasts.map((t) => (
        <div key={t.id} className="toast" style={t.tone === 'bad' ? { background: 'var(--bad)', color: '#fff' } : undefined}>
          {t.message}
        </div>
      ))}
    </div>
  );
}
